import { setCurrentUser, User } from "../auth";
import { useDispatch, useSelector } from "react-redux";
import { ESRState } from "../types/data";
import { ESRThunkDispatch } from "../actions/form";

export function useCurrentUser(): [User | null, (user: User | null) => void] {
	const user = useSelector((state: ESRState) => state.current_user);
	const dispatch = useDispatch<ESRThunkDispatch>();

	const setUser = (user: User | null) => {
		setCurrentUser(user); // local storage
		dispatch({ type: "SET_USER", user });
	};

	return [user, setUser];
}
